export default "__VITE_ASSET__Bji3QZLu__"